<div class="main-wrapper"><v-sheet class="bookings-table-container pa-6 elevation-2"><CustomerBookings :bookings="bookings"></CustomerBookings></v-sheet></div>